import { gql, useQuery } from '@apollo/client';
import { OnlineOrderReportHourlyOrderDistributionItem } from '@client/graphql/types/graphql';

interface OnlineOrderHourlyDistributionData {
  onlineOrderReport_owner_getHourlyDistribution: OnlineOrderReportHourlyOrderDistributionItem[];
}

interface OnlineOrderHourlyDistributionVars {
  branchId: string;
  dateRange: {
    startDate: string;
    endDate: string;
  };
}

const ONLINE_ORDER_HOURLY_DISTRIBUTION_QUERY = gql`
  query OnlineOrderReportHourlyDistribution($branchId: ID!, $dateRange: OnlineOrderReportDateRangeInput!) {
    onlineOrderReport_owner_getHourlyDistribution(branchId: $branchId, dateRange: $dateRange) {
      hour
      orderCount
      revenue
    }
  }
`;

export default function useOnlineOrderHourlyDistribution(branchId: string, startDate: string, endDate: string) {
  return useQuery<OnlineOrderHourlyDistributionData, OnlineOrderHourlyDistributionVars>(
    ONLINE_ORDER_HOURLY_DISTRIBUTION_QUERY,
    {
      variables: {
        branchId,
        dateRange: {
          startDate,
          endDate,
        },
      },
      skip: !branchId || !startDate || !endDate,
    },
  );
}
